export const BUSINESS_CASE_PLANNED_ACTIVITY_KINDS = ['task', 'testDrive'] as const;
